/**
 * @author jl
 * @version  2016-10-14
 * @description 底部选择js
 */
// build module
$(function () {
});



// WEBPACK FOOTER //
// ./src/module/footer/footer.js